import {
  fetchProductsInCartAction,
  fetchProductsInFavoriteAction,
  signInAction,
  signOutAction,
  editProfileStateAction,
} from "./actions";

import { db, auth, FirebaseTimestamp, provider } from "../../firebase/index";
import { push, goBack } from "connected-react-router";
import { isValidEmailFormat } from "../../functions/common";
import {
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  signInWithPopup,
} from "firebase/auth";
import {
  doc,
  setDoc,
  collection,
  query,
  getDocs,
  updateDoc,
  where,
  deleteDoc,
  runTransaction,
} from "firebase/firestore";
import { hideLoadingAction, showLoadingAction } from "../loading/actions";
import { initProductsAction } from "../products/actions";
import { PERMISSIONS } from "../../constants/permissions";
import { AUTH_ERROR, NO_USER_DATA, SUCCESS } from "../../constants/errors";
import { getWorkerInfoByEmail } from "../../functions/users";
import { resolveWorkerName } from "../../functions/worker/resolveWorkerName";
import { clearGmailAccessToken } from "../../functions/gmail/gmailToken";
import {
  assertFreshBuildInTransaction,
  StaleBuildError,
} from "../../functions/appVersion/versionGate";
import { shouldEnforceVersionGate } from "../../functions/appVersion/versionGateCore";
import {
  INITAL_DAYS,
  IS_SEND_MAIL,
  SEND_TIME,
} from "../../constants/initialSendMail";

export const addProductToCart = (addedProduct) => {
  // 戻り値: カートへ追加できたときtrue
  return async (dispatch, getState) => {
    const uid = getState().users.uid;
    const cartCollectionRef = collection(db, "users", uid, "cart");
    try {
      // 既存行(旧形式のランダムIDを含む)を検索して対象docを決める。
      // 見つからなければ(社外番号+サイズ)から決まる決定論的IDを使う。
      // 同時に実行されても全員が同一docに収束するため、行の分裂が起きない。
      const querySnapshot = await getDocs(
        query(
          cartCollectionRef,
          where("idout", "==", addedProduct.idout),
          where("size", "==", addedProduct.size)
        )
      );
      const deterministicRef = doc(
        cartCollectionRef,
        `${encodeURIComponent(String(addedProduct.idout))}__${encodeURIComponent(
          String(addedProduct.size)
        )}`
      );
      const targetRef = querySnapshot.empty
        ? deterministicRef
        : querySnapshot.docs[0].ref;

      await runTransaction(db, async (transaction) => {
        // 旧ビルドのタブからの書き込みを止める(バージョンゲート)
        if (shouldEnforceVersionGate(window.location.hostname)) {
          await assertFreshBuildInTransaction(transaction);
        }
        let cartRef = targetRef;
        let cartSnap = await transaction.get(cartRef);
        if (!cartSnap.exists() && cartRef.id !== deterministicRef.id) {
          // 事前検索で見つけた旧形式docが直前に削除された場合は決定論的IDへ切替
          cartRef = deterministicRef;
          cartSnap = await transaction.get(cartRef);
        }
        if (cartSnap.exists()) {
          // 既存の商品がある場合、quantity を更新する
          const existingProduct = cartSnap.data();
          transaction.update(cartRef, {
            quantity: existingProduct.quantity + addedProduct.quantity,
            totalPrice: existingProduct.totalPrice + addedProduct.totalPrice,
          });
        } else {
          // 既存の商品がない場合、新しい商品を追加する
          transaction.set(cartRef, { ...addedProduct, cartId: cartRef.id });
        }
      });
      return true;
    } catch (error) {
      if (error instanceof StaleBuildError) {
        alert(
          "新しいバージョンが公開されています。ページを再読み込みしてから、もう一度お試しください。"
        );
        return false;
      }
      console.error("カートへの追加に失敗しました:", error);
      alert(
        "カートへの追加に失敗しました。通信環境をご確認のうえ、もう一度お試しください。"
      );
      return false;
    }
  };
};

export const addProductToFavorite = (addedProduct) => {
  return async (dispatch, getState) => {
    const uid = getState().users.uid;
    const favoriteCollectionRef = collection(db, "users", uid, "favorite");

    // 新しい商品を追加する前に、既存の商品をチェックする
    const querySnapshot = await getDocs(
      query(
        favoriteCollectionRef,
        where("idout", "==", addedProduct.idout),
        where("size", "==", addedProduct.size)
      )
    );
    let existingProduct = null;

    querySnapshot.forEach((doc) => {
      // 既存の商品を見つけた場合
      existingProduct = { id: doc.id, ...doc.data() };
    });

    if (existingProduct) {
      // 既存の商品がある場合、quantity を更新する
      const newQuantity = existingProduct.quantity + addedProduct.quantity;
      const newTotalPrice =
        existingProduct.totalPrice + addedProduct.totalPrice;
      await updateDoc(doc(db, "users", uid, "favorite", existingProduct.id), {
        quantity: newQuantity,
        totalPrice: newTotalPrice,
      });
    } else {
      // 既存の商品がない場合、新しい商品を追加する
      const newFavoriteId = doc(favoriteCollectionRef).id;
      addedProduct["favoriteId"] = newFavoriteId;
      await setDoc(doc(favoriteCollectionRef, newFavoriteId), addedProduct);
    }

    //dispatch(push("/"));
  };
};

export const editUserProfile = (iconPath, username, uid) => {
  return async (dispatch) => {
    const updateValue = {
      icon_path: iconPath,
      username: username,
    };
    const usersRef = collection(db, "users");
    const userDocRef = doc(usersRef, uid);

    updateDoc(userDocRef, updateValue)
      .then(() => {
        alert("ユーザー情報を更新しました。");
        dispatch(editProfileStateAction(updateValue));
        dispatch(goBack());
      })
      .catch((error) => {
        console.error(error);
        alert("ユーザー情報の更新に失敗しました。");
      });
  };
};

export const fetchOrdersHistoryByOrder = async (order_id) => {
  try {
    let list = [];
    const ordersRef = collection(db, "orders");

    // クエリを作成
    const q = query(ordersRef, where("order_id", "==", order_id));

    // クエリを実行し、データを取得
    const snapshots = await getDocs(q);

    snapshots.forEach((snapshot) => {
      const data = snapshot.data();
      list.push(data);
    });

    // ソート処理
    list.sort((a, b) => {
      const dateA = a.created_at ? a.created_at.toDate() : null;
      const dateB = b.created_at ? b.created_at.toDate() : null;

      if (dateB && dateA) {
        return dateB - dateA;
      } else if (dateB) {
        return 1;
      } else if (dateA) {
        return -1;
      } else {
        return 0;
      }
    });

    return list; // 正常にデータを返す
  } catch (error) {
    console.error("Error fetching orders:", error);
    return []; // エラー時に空リストを返す
  }
};

export const fetchProductsInCart = (products) => {
  return async (dispatch) => {
    dispatch(fetchProductsInCartAction(products));
  };
};
export const fetchProductsInFavorite = (products) => {
  return async (dispatch) => {
    dispatch(fetchProductsInFavoriteAction(products));
  };
};

export const listenAuthState = () => {
  return async (dispatch) => {
    return onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // emailを使用してusersコレクションを検索
          const usersRef = collection(db, "users");
          const q = query(usersRef, where("email", "==", user.email));

          // サーバーからのデータ取得を優先（不完全なキャッシュデータを避けるため）
          let querySnapshot;
          try {
            querySnapshot = await getDocs(q, { source: 'server' });
          } catch (serverError) {
            console.warn('サーバーからのデータ取得に失敗。キャッシュを使用します。', serverError);
            // フォールバック: キャッシュから取得
            querySnapshot = await getDocs(q, { source: 'cache' });
          }

          if (querySnapshot.empty) {
            dispatch(push("/signin"));
            console.log("signOut16");
            return;
          }

          // 最初に見つかったユーザーデータを使用
          const userDoc = querySnapshot.docs[0];
          const data = userDoc.data();

          // 必須フィールドの検証（ネットワーク不安定時やキャッシュからの不完全なデータを検出）
          const requiredFields = [
            'email',
            'uid',
            'username',
            'usernumber',
            'departmentid',
            'departmentname',
            'role'
          ]

          const missingFields = requiredFields.filter(field => {
            const value = data[field]
            return value === undefined || value === null || value === ''
          })

          if (missingFields.length > 0) {
            console.error('Firestoreから取得したユーザーデータに必須フィールドが欠落しています', {
              missingFields,
              data
            })
            dispatch(push("/signin"));
            console.log("signOut_incomplete_data");
            return;
          }

          // 職場氏名の自己修復。
          // 社員マスタ(workers)側で旧姓を「職場氏名」として登録しても、
          // users.username は初回サインイン時の値のまま更新されないため
          // (以後のログインは users を読むだけ)、ここで突き合わせて直す。
          // workers に居ない人(派遣等)や解決結果が空のときは何もしない(名前を消さない)。
          let username = data.username;
          try {
            const workerInfo = await getWorkerInfoByEmail(data.email);
            const resolvedName = resolveWorkerName(workerInfo);
            if (workerInfo && resolvedName && resolvedName !== username) {
              await updateDoc(userDoc.ref, {
                username: resolvedName,
                updated_at: FirebaseTimestamp.now(),
              });
              username = resolvedName;
            }
          } catch (error) {
            // 突き合わせに失敗してもログインは継続する
            console.warn("職場氏名の同期に失敗しました:", error);
          }

          dispatch(
            signInAction({
              usernumber: data.usernumber,  // 検証済みなので || "" を削除
              departmentid: data.departmentid,
              departmentname: data.departmentname,
              email: data.email,
              isSignedIn: true,
              role: data.role,
              payment_method_id: data.payment_method_id || "",  // オプショナルなので保持
              uid: data.uid,
              username,
              order_email: data.order_email,
              order_base_id: data.order_base_id,
              order_base_name: data.order_base_name,
              order_department_id: data.order_department_id,
              order_department_name: data.order_department_name,
              created_at: data.created_at,
              updated_at: data.updated_at,
              sign: data.sign,
            })
          );
        } catch (error) {
          console.log("signOut7");
          console.error("Error fetching user data:", error);
          dispatch(push("/signin"));
        }
      } else {
        dispatch(push("/signin"));
        console.log("signOut8");
      }
    });
  };
};
export const resetPassword = (email) => {
  return async (dispatch) => {
    if (!isValidEmailFormat(email)) {
      alert("メールアドレスの形式が不正です。");
      return false;
    } else {
      sendPasswordResetEmail(auth, email)
        .then(() => {
          alert(
            "入力されたアドレスにパスワードリセット用のメールをお送りしました"
          );
          dispatch(push("/signin"));
        })
        .catch(() => {
          alert(
            "パスワードリセットに失敗しました 通信環境を確認して再度お試しください"
          );
        });
    }
  };
};

export const saveAddress = (address) => {
  return async (dispatch, getState) => {
    const state = getState();
    const userId = state.users.uid;
    const usersRef = collection(db, "users");
    const addressDocRef = doc(usersRef, userId, "addresses", userId);

    setDoc(addressDocRef, address)
      .then(() => {
        alert("入力いただいた情報を保存しました。");
        dispatch(push("/bank"));
      })
      .catch((error) => {
        alert(
          "情報の保存に失敗しました。通信環境を確認してもう1度お試しください。"
        );
        throw new Error(error);
      });
  };
};

export const signIn = (isMobile) => {
  // const navigate = useNavigate();
  return async (dispatch) => {
    dispatch(showLoadingAction("サインイン..."));
    try {
      // provider.setCustomParameters({
      //   prompt: "consent",
      //   access_type: "offline", // リフレッシュトークンを取得するために必要
      // });
      const result = await signInWithPopup(auth, provider);

      const user = result.user;
      if (!user) {
        dispatch(hideLoadingAction());
        return AUTH_ERROR;
      }

      // const userDocRef = doc(db, "users", user.uid);
      // const userDocSnap = await getDoc(userDocRef);
      // emailを使用してusersコレクションを検索
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("email", "==", user.email));
      const querySnapshot = await getDocs(q);
      if (querySnapshot.empty) {
        dispatch(hideLoadingAction());
        const timestamp = FirebaseTimestamp.now();
        const workerInfo = await getWorkerInfoByEmail(user.email);
        const newUser = {
          usernumber: workerInfo?.B178_id?.value || "",
          email: user.email,
          order_email: "",
          // 職場氏名(旧姓等)が登録されていればそちらを使う。
          // ここで通常氏名を入れてしまうと users.username に誤った氏名が永続化され、
          // 以後のログインは users を読むだけなので固定化してしまう。
          username: resolveWorkerName(workerInfo),
          departmentid: workerInfo?.B178_syozoku_cd?.value || "",
          departmentname: workerInfo?.B178_syozoku_name?.value || "",
          isSignedIn: true,
          role: PERMISSIONS.NORMAL_USER,
          payment_method_id: "",
          uid: user.uid,
          order_base_id: "",
          order_base_name: "",
          order_department_id: "",
          order_department_name: "",
          created_at: timestamp,
          updated_at: timestamp,
          sign: "",
          isSend: IS_SEND_MAIL,
          sendTime: SEND_TIME,
          days: INITAL_DAYS,
        };

        await setDoc(doc(db, "users", user.uid), newUser);
        dispatch(signInAction(newUser));
        dispatch(push("/"));
        dispatch(hideLoadingAction());
        return SUCCESS;
      }

      // 最初に見つかったユーザーデータを使用
      const userDoc = querySnapshot.docs[0];
      const userDocSnap = userDoc.data();
      let userData;
      if (userDocSnap) {
        userData = userDocSnap;
      } else {
        dispatch(hideLoadingAction());
        //ユーザを検索
        const timestamp = FirebaseTimestamp.now();
        const workerInfo = await getWorkerInfoByEmail(user.email);
        const newUser = {
          usernumber: workerInfo?.B178_id?.value || "",
          email: user.email,
          // 職場氏名(旧姓等)を優先する(上のブロックと同じ理由)
          username: resolveWorkerName(workerInfo),
          departmentid: workerInfo?.B178_syozoku_cd?.value || "",
          departmentname: workerInfo?.B178_syozoku_name?.value || "",
          isSignedIn: true,
          role: PERMISSIONS.NORMAL_USER,
          payment_method_id: "",
          uid: user.uid,
          order_email: "",
          order_base_id: "",
          order_base_name: "",
          order_department_id: "",
          order_department_name: "",
          created_at: timestamp,
          updated_at: timestamp,
          sign: "",
          isSend: IS_SEND_MAIL,
          sendTime: SEND_TIME,
          days: INITAL_DAYS,
        };
        //userデータを新規作成
        setDoc(doc(db, "users", user.uid), newUser).then(() => {
          dispatch(push("/"));

          return SUCCESS;
        });
      }
      dispatch(
        signInAction({
          usernumber: userData.usernumber,
          email: userData.email,
          username: userData.username,
          departmentid: userData.departmentid,
          departmentname: userData.departmentname,
          isSignedIn: true,
          role: userData.role,
          payment_method_id: userData.payment_method_id,
          uid: userData.uid,
          order_email: userData.order_email,
          order_base_id: userData.order_base_id,
          order_base_name: userData.order_base_name,
          order_department_id: userData.order_department_id,
          order_department_name: userData.order_department_name,
          created_at: userData.created_at,
          updated_at: userData.updated_at,
          sign: userData.sign,
          isSend: userData.isSend,
          sendTime: userData.sendTime,
          days: userData.days,
        })
      );

      dispatch(hideLoadingAction());
      dispatch(push("/"));

      return SUCCESS;
    } catch (error) {
      console.error("Google Sign-In Error:", error);
      dispatch(hideLoadingAction());
      return NO_USER_DATA;
    }
  };
};

export const signOutUser = () => {
  return async (dispatch) => {
    dispatch(showLoadingAction("サインアウト..."));
    signOut(auth)
      .then(() => {
        dispatch(signOutAction());
        dispatch(initProductsAction());
        dispatch(hideLoadingAction());
        clearGmailAccessToken();
        dispatch(push("/signin"));
      })
      .catch(() => {
        dispatch(hideLoadingAction());
        throw new Error("ログアウトに失敗しました。");
      });
  };
};

export const registerUser = (
  username,
  email,

  usernumber,
  userdepnumber,
  userdepname,
  order_base_id,
  order_base_name,
  order_department_id,
  order_department_name,
  role,
  order_email,
  sign,
  isSend,
  sendTime,
  days
) => {
  return async (dispatch) => {
    let alertString = "";
    // if (username === "") {
    //   alertString = "ユーザー名";
    // }
    // if (usernumber === "") {
    //   alertString += alertString.length > 0 ? "、社員番号" : "社員番号";
    // }
    // if (userdepnumber === "") {
    //   alertString += alertString.length > 0 ? "、部署コード" : "部署コード";
    // }
    // if (userdepname === "") {
    //   alertString += alertString.length > 0 ? "、部署名" : "部署名";
    // }
    if (!order_base_id || !order_base_name) {
      alertString += alertString.length > 0 ? "、発注拠点" : "発注拠点";
    }
    if (!order_department_id || !order_department_name) {
      alertString += alertString.length > 0 ? "、発注部署" : "発注部署";
    }
    if (!role) {
      alertString += alertString.length > 0 ? "、権限" : "権限";
    }
    if (alertString.length > 0) {
      alert(alertString + "の入力が不正です");
      return false;
    }

    // Validations
    // if (!isValidRequiredInput(username, email, password, confirmPassword)) {
    //   alert("必須項目が未入力です。");
    //   return false;
    // }

    if (!isValidEmailFormat(email)) {
      alert("メールアドレスの形式が不正です。もう1度お試しください。");
      return false;
    }
    if (!isValidEmailFormat(order_email)) {
      alert(
        "発注担当者のメールアドレスの形式が不正です。もう1度お試しください。"
      );
      return false;
    }

    try {
      dispatch(showLoadingAction("登録中..."));

      // メールアドレスの重複チェック
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("email", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        dispatch(hideLoadingAction());
        alert("このメールアドレスは既に登録されています。");
        return false;
      }

      // 新しいドキュメント参照を作成（IDは自動生成）
      const newUserRef = doc(collection(db, "users"));
      const uid = newUserRef.id;

      const timestamp = FirebaseTimestamp.now();

      const userInitialData = {
        usernumber: usernumber,
        username: username,
        departmentid: userdepnumber,
        departmentname: userdepname,
        created_at: timestamp,
        email: email,
        isSignedIn: true,
        role: role,
        payment_method_id: "",
        uid: uid, // 自動生成されたIDをuidフィールドにセット
        updated_at: timestamp,
        order_base_id,
        order_base_name,
        order_department_id,
        order_department_name,
        order_email,
        sign,
        isSend,
        sendTime,
        days,
      };

      // Firestoreにユーザーデータを保存
      await setDoc(newUserRef, userInitialData);

      dispatch(hideLoadingAction());
      // 成功時の処理（例：ホーム画面へのリダイレクト）
      // dispatch(push("/"));
      return true;
    } catch (error) {
      dispatch(hideLoadingAction());
      console.error("Error registering user:", error);
      alert("アカウント登録に失敗しました。もう1度お試しください。");
      return false;
    }
  };
};

export const updateUser = (
  userId,
  username,
  email,
  usernumber,
  userdepnumber,
  userdepname,
  order_base_id,
  order_base_name,
  order_department_id,
  order_department_name,
  role,
  order_email,
  sign,
  isSend,
  sendTime,
  days,
  stateUpdate = false
) => {
  return async (dispatch) => {
    let alertString = "";

    if (!order_base_id || !order_base_name) {
      alertString += alertString.length > 0 ? "、発注拠点" : "発注拠点";
    }
    if (!order_department_id || !order_department_name) {
      alertString += alertString.length > 0 ? "、発注部署" : "発注部署";
    }
    if (!role) {
      alertString += alertString.length > 0 ? "、権限" : "権限";
    }
    if (alertString.length > 0) {
      alert(alertString + "の入力が不正です");
      return false;
    }

    if (!isValidEmailFormat(email)) {
      alert("メールアドレスの形式が不正です。もう1度お試しください。");
      return false;
    }
    if (!isValidEmailFormat(order_email)) {
      alert(
        "発注担当者のメールアドレスの形式が不正です。もう1度お試しください。"
      );
      return false;
    }

    try {
      dispatch(showLoadingAction("ユーザー情報を更新中..."));

      // ユーザードキュメントへの参照を取得
      const userRef = doc(db, "users", userId);

      // 更新データの作成
      const timestamp = FirebaseTimestamp.now();

      const updatedUserData = {
        usernumber: usernumber,
        username: username,
        departmentid: userdepnumber,
        departmentname: userdepname,
        updated_at: timestamp,
        email: email,
        role: role,
        order_base_id: order_base_id,
        order_base_name: order_base_name,
        order_department_id: order_department_id,
        order_department_name: order_department_name,
        order_email: order_email,
        sign: sign,
        isSend: isSend,
        sendTime: sendTime,
        days: days,
      };
      // Firestoreのユーザーデータを更新
      await updateDoc(userRef, updatedUserData);

      dispatch(hideLoadingAction());

      // stateUpdateの処理を削除（修正理由）:
      // Auth.jsxのonSnapshotがFirestoreの変更をリアルタイムで監視しているため、
      // ここで明示的にdispatchする必要はありません。
      // また、updatedUserDataには uid, created_at, payment_method_id などの
      // 重要なフィールドが含まれていないため、不完全なデータでstateが更新される
      // 問題がありました。Firestoreの更新後、Auth.jsxが自動的に最新データを取得します。
      // if (stateUpdate) {
      //   dispatch(signInAction(updatedUserData));
      // }

      // alert("ユーザー情報を更新しました。");
      return true;
    } catch (error) {
      dispatch(hideLoadingAction());
      console.error("Error updating user:", error);
      alert("ユーザー情報の更新に失敗しました。もう1度お試しください。");
      return false;
    }
  };
};

export const updateRole = (userid, role) => {
  return async (dispatch) => {
    let alertString = "";
    // バリデーションチェック
    if (userid === "") {
      alertString = "ユーザーID";
    }
    if (PERMISSIONS.indexOf(role) === -1) {
      alertString += alertString.length > 0 ? "、権限" : "権限";
    }
    if (alertString.length > 0) {
      alert(alertString + "の入力が不正です");
      return false;
    }

    dispatch(showLoadingAction("更新中..."));
    const timestamp = FirebaseTimestamp.now();

    // 更新するユーザー情報
    const userUpdateData = {
      updated_at: timestamp,
      role: role,
    };

    // Firestoreのusersコレクションを更新
    updateDoc(doc(db, "users", userid), userUpdateData)
      .then(() => {
        //alert("ユーザー情報を更新しました。");
        //dispatch(editProfileStateAction(userUpdateData));
        //dispatch(goBack());

        //dispatch(push("/"));
        dispatch(hideLoadingAction());
      })
      .catch((error) => {
        dispatch(hideLoadingAction());
        alert("情報の更新に失敗しました。もう1度お試しください。");
        throw new Error(error);
      });
  };
};

export const deleteUser = (userId) => {
  return async (dispatch) => {
    try {
      dispatch(showLoadingAction("ユーザーを削除中..."));

      // ユーザードキュメントへの参照を取得
      const userRef = doc(db, "users", userId);

      // Firestoreからユーザーデータを削除
      await deleteDoc(userRef);

      dispatch(hideLoadingAction());
      return true;
    } catch (error) {
      dispatch(hideLoadingAction());
      console.error("Error deleting user:", error);
      alert("ユーザーの削除に失敗しました。もう1度お試しください。");
      return false;
    }
  };
};
